import { createSlice } from '@reduxjs/toolkit'
import { getUsersListAction, updateUserAction } from '../actions/usersAction';

export const usersSlice = createSlice({
    name: 'users',
    initialState: {
        status: 'idle',
        error: "",
        usersList: [],
        selectedUser: null
    },
    reducers: {
        setSelectedUser: (state, action) => {
            return {
                ...state,
                selectedUser: action.payload
            }
        }
    },
    extraReducers(builder) {
        // Fetch All Users List
        builder
            .addCase(getUsersListAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getUsersListAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                let tempUsersList = state.usersList;
                state.usersList = [...tempUsersList, action.payload.data];
            })
            .addCase(getUsersListAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            // Update User
            .addCase(updateUserAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(updateUserAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.selectedUser = action.payload.data;
            })
            .addCase(updateUserAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to update"
            })
    }
})

export const {
    setSelectedUser,
} = usersSlice.actions

export default usersSlice.reducer